import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';

/**
 * Override the auto-discovered entity detail page to suppress the
 * outer PluginHeader that displays "Catalog Entity". The entity page
 * already renders its own EntityHeader with the entity name, kind,
 * and breadcrumbs — the outer header is redundant.
 *
 * Using `.override({ params })` preserves all inputs (headers,
 * contents, contextMenuItems), config (groups, showNavItemIcons),
 * and the full loader logic from the upstream plugin.
 */
const catalogEntityPage = catalogPlugin
  .getExtension('page:catalog/entity')
  .override({
    params: { noHeader: true },
  });

export const catalogEntityPageModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogEntityPage],
});
